import { AxiosResponse } from 'axios';
import { Result } from '../models/common/resultResponse';
import { IUserPreferencesFavoriteSearchApi } from './base';
import { SaveUserPreferencesFavoriteSearchRequest } from "../models/request/userPreferencesFavoriteSearchRequest";
import { api } from './base/api';
import { UserPredefinedSearchSaveRequest } from '../models/request/userPredefinedSearchSaveRequest';
import { KeyValue } from '../models/common';

const baseRoute: string = 'UserPreferencesFavoriteSearch';

export class UserPreferencesFavoriteSearchApi extends IUserPreferencesFavoriteSearchApi {
  getUserPreferencesFavoriteSearch<T>(
    routeUrl: string
  ): Promise<AxiosResponse<Result<T>>> {
    return api.get(`${baseRoute}`, { params: { routeUrl } });
  }

  saveUserPreferencesFavoriteSearch(
    request: SaveUserPreferencesFavoriteSearchRequest
  ): Promise<AxiosResponse<Result<void>>> {
    return api.post(`${baseRoute}`, request);
  }

  saveUserPredefinedSearch(
    request: UserPredefinedSearchSaveRequest
  ): Promise<AxiosResponse<Result<void>>> {
    return api.post(`${baseRoute}/saveUserPredefinedSearch`, request);
  }

  deleteUserPredefinedSearch(
    guidUserPredefinedSearch: string
  ): Promise<AxiosResponse<Result<any>>> {
    return api.delete(`${baseRoute}/deleteUserPredefinedSearch`, { params: { guidUserPredefinedSearch } });
  }

  getDomainUserPredefinedSearch(
    routeUrl: string
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domainUserPredefinedSearch`, { params: { routeUrl } });
  }

  getDetailsUserPredefinedSearch<T>(
    guidUserPredefinedSearch: string
  ): Promise<AxiosResponse<Result<T>>> {
    return api.get(`${baseRoute}/getDetailsUserPredefinedSearch`, { params: { guidUserPredefinedSearch } });
  }
}
